var _style, _rect, _path, _path2, _path3, _line, _polyline, _polyline2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlameDetector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.4,
    y: 0.5,
    className: "st0",
    width: 13.1,
    height: 12.9
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,0.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14.6,13.4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.4,11.4"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 6.3,
    y1: 7.5,
    x2: 9.7,
    y2: 7.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "10.8,7.5 9.7,7.5 8,3.7 6.3,7.5 5.3,7.5 "
  })), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1.4,13.4 1.4,15.5 14.6,15.5 14.6,13.4 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlameDetector);
export default __webpack_public_path__ + "static/media/FlameDetector.62f5273ae55ff454bc631beac76f1ac2.svg";
export { ForwardRef as ReactComponent };